/* eslint-disable class-methods-use-this */

export default class Newsletter {
    constructor(vm) {
        this.vm = vm;
    }

    get(event) {
        let trackingObject = null;

        switch (event) {
            case 'newsletter-yes':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'minside',
                    'eventAction': 'click popup nyhedsbrev permission',
                    'eventLabel': 'ja tak',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;
            
            case 'newsletter-no':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'minside',
                    'eventAction': 'click popup nyhedsbrev permission',
                    'eventLabel': 'nej tak',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;
            
            case 'newsletter-hide':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'minside',
                    'eventAction': 'click popup nyhedsbrev permission',
                    'eventLabel': 'luk på kryds',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
        }
        
        return trackingObject;
    }
}
